import { configureStore } from '@reduxjs/toolkit';

import authSlice from './authSlice';
import uiSlice from './uiSlice';
import portalModalDialogSlice from './portalModalDialogSlice';

const store = configureStore({
  reducer: {
    auth: authSlice,
    ui: uiSlice,
    portalModalDialogs: portalModalDialogSlice
  }
});

export default store;
